import { SvgIcon, SvgIconProps } from '@mui/material'

export const SubsidiariesSidebar = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon role="img" viewBox="0 0 12 17" fill="none" {...props}>
      <path
        d="M0.599609 14.9996V2.86628C0.599609 2.53491 0.868238 2.26628 1.19961 2.26628H5.59961V1.19961C5.59961 0.868238 5.86824 0.599609 6.19961 0.599609H9.99961C10.331 0.599609 10.5996 0.868239 10.5996 1.19961V14.9996C10.5996 15.331 10.331 15.5996 9.99961 15.5996H1.19961C0.868238 15.5996 0.599609 15.331 0.599609 14.9996Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </SvgIcon>
  )
}
